import { PlaycastData, initialPlaycastData } from './player/types';
import { ReactNode, createContext, useEffect, useSyncExternalStore } from 'react';
import { captureStore } from '@playcastdotio/InputCapture';
import { gamepadStore } from '@playcastdotio/MobileGamepad';
import { handleEvent, setGamepadState } from '../api/modules/hostMessaging/inputEvents';

export const PlaycastContext = createContext<PlaycastData>(initialPlaycastData);

type LocalProps = {
  children?: ReactNode;
};

export const PlayerContext = (props: LocalProps) => {
  const { children } = props;
  const gamepad = useSyncExternalStore(gamepadStore.subscribeGamepad, gamepadStore.getGamepad);

  const event = useSyncExternalStore(captureStore.subscribeEvent, captureStore.getEvent);

  // This is processing for the mobile gamepad overlay
  useEffect(() => {
    if (gamepad) {
      setGamepadState(gamepad);
    }
  }, [gamepad]);

  useEffect(() => {
    if (event) {
      handleEvent(event);
    }
  }, [event]);

  return <PlaycastContext.Provider value={initialPlaycastData}>{children}</PlaycastContext.Provider>;
};
